export const url = 'https://afbrserver.herokuapp.com/'

// export const url = 'http://localhost:8000/'